export const features = {
  intro: 'Introduction conversation',
  performance: {
    basic: 'Static performance analysis for 3 pages',
    advanced: 'Dynamic Performance analysis for 3 pages',
    premium: 'Static & Dynamic performance analysis for your entire web app',
  },
  qa: {
    basic: 'Superficial manual QA for 1 page',
    advanced: 'Dynamic QA for a process 3 pages',
    premium: 'E2E QA for your entire web app',
  },
  design: {
    basic: 'Basic UI/UX review of 1 page, written ideas for improvements',
    advanced: 'Advanced UI/UX review of 1 page, with improved suggested design',
    premium:
      'Advanced UI/UX review of your entire app with improved suggested design',
  },
  accessibility: {
    basic: 'Basic accessibility analysis for 3 pages',
    advanced: 'Advanced accessibility analysis for 3 pages',
    premium: 'Accessibility analysis for your entire web app',
  },
  product: {
    basic: 'Analysis of 1 feature of your product',
    advanced: 'Analysis of 2 features of your product',
    premium: 'Analysis of your entire product',
  },
};

export const currencySymbol = '$';

export const plans = [
  {
    title: 'Basic',
    features: [
      features.intro,
      features.product.basic,
      features.qa.basic,
      features.design.basic,
      features.performance.basic,
      features.accessibility.basic,
    ],
    price: '95',
  },
  {
    title: 'Advanced',
    features: [
      features.intro,
      features.product.advanced,
      features.qa.advanced,
      features.design.advanced,
      features.performance.basic,
      features.performance.advanced,
      features.accessibility.basic,
      features.accessibility.advanced,
    ],
    price: '395',
  },
  {
    title: 'Premium',
    features: [
      features.intro,
      features.product.premium,
      features.qa.premium,
      features.design.premium,
      features.performance.premium,
      features.accessibility.premium,
    ],
    price: undefined,
  },
];
